import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { AppLayout } from 'src/layouts';
import { LOGIN_PATH, GLOBAL_ADMIN_SITE_HEADER, TENANT_SWITCH_PATH } from '../../config';
import { NAV_ITEMS_HEADER_HOME_PAGE } from 'src/features';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { useMemo } from 'react';
import GlobalAdminSitesManagement from 'src/features/global-admin-sites-management/pages/GlobalAdminSitesManagement';

export const GlobalAdminSiteManagementElement = ({ isSuperAdmin }: ElementProps) => {
  const { loggedIn } = useAuthentication();

  const uniqueRedirectPath = useMemo(() => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin) return TENANT_SWITCH_PATH;
    return undefined;
  }, [loggedIn.value, isSuperAdmin]);

  const GlobalAdminSiteManagementElement = useMemo(
    () => (
      <Protected
        isAuthenticated={loggedIn.value}
        isAuthorized={isSuperAdmin}
        uniqueRedirectPath={uniqueRedirectPath}
      >
        <AppLayout
          headerTitle={GLOBAL_ADMIN_SITE_HEADER}
          headerNavItems={NAV_ITEMS_HEADER_HOME_PAGE}
          isCustomerAccountPage={true}
          isSuperAdmin={isSuperAdmin}
        >
          <GlobalAdminSitesManagement />
        </AppLayout>
      </Protected>
    ),
    [loggedIn.value, isSuperAdmin, uniqueRedirectPath]
  );

  const getGlobalAdminSiteManagementElement = () => {
    if (!loggedIn.loaded) {
      return <LoadingElement />;
    }

    return GlobalAdminSiteManagementElement;
  };

  return getGlobalAdminSiteManagementElement();
};
